import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import { Button } from './Button';
import { Lightbox } from './Lightbox';
import { Reveal } from './Reveal';
import { CandidateCard } from './CandidateCard';
import { CandidateCardWide } from './CandidateCardWide';
import { CandidateProfileModal } from './CandidateProfileModal';
import { candidates } from '../data/candidates';
import { election } from '../data/election';
import type { Candidate } from '../types/landing';
type CandidatesSectionProps = {
  layout?: 'dosPorFila' | 'cuatroPorFila';
};
export function CandidatesSection({
  layout = 'dosPorFila'
}: CandidatesSectionProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [posterOpen, setPosterOpen] = useState(false);
  const open = (c: Candidate) => setActiveIndex(candidates.findIndex(x => x.id === c.id));
  const navigate = (dir: 1 | -1) => setActiveIndex(i => i === null ? i : (i + dir + candidates.length) % candidates.length);
  return <section id="lista" className="bg-[#F4F1EB] py-14 md:py-16" data-id="element-100" data-mp="7zzv0jk6002m">
      <div className="mx-auto max-w-7xl px-6" data-id="element-101" data-mp="7x3wat0ht7d4">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end" data-id="element-102" data-mp="31euej103edn">
          <Reveal className="max-w-3xl" data-id="element-103" data-mp="3u5wtvea98l3u">
            <span aria-hidden className="flex h-1.5 w-12 overflow-hidden rounded-full" data-id="element-104" data-mp="3u4v6qbfys85r">
              <span className="w-6 bg-accent-gold" data-id="element-105" data-mp="3q4jkwvbv81sp" />
              <span className="w-3 bg-primary" data-id="element-106" data-mp="3l5qajbrvkqwr" />
              <span className="w-3 bg-secondary-maroon" data-id="element-107" data-mp="3l7kw8saz0n1w" />
            </span>
            <h2 className="type-h2 mt-4 uppercase text-primary" data-id="element-108" data-mp="3ge8ft5gg3mk8">
              Vota <span className="text-accent-gold" data-id="element-109" data-mp="3bfx56sibt80y">Lista No. 1</span>
            </h2>
            <p className="type-lead mt-4 border-l-4 border-accent-gold pl-4 text-primary" data-id="element-110" data-mp="36h3u16qiht3y">
              Elige la Junta Directiva · <span className="text-secondary-maroon" data-id="element-111" data-mp="32g0eklcdlz39">Período 2027 – 2030</span>
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground/70 md:text-lg" data-id="element-112" data-mp="2xgnozsu4edwz">
              Empresarios con visión, experiencia y compromiso. Haz clic en cada candidato para conocer su perfil.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-113" data-mp="2rv6flls8dv9l">
            <Button variant="outline" leftIcon={<ImageIcon className="h-4 w-4" data-id="element-115" data-mp="2dv5d61wbifs0" />} onClick={() => setPosterOpen(true)} data-id="element-114" data-mp="2rs2403cfrx8w">
              Ver pieza oficial
            </Button>
          </Reveal>
        </div>

        {layout === 'dosPorFila' ? <div className="mt-12 grid grid-cols-1 gap-x-10 gap-y-10 px-2 lg:grid-cols-2" data-id="element-116" data-mp="36j1an8tpobpu">
            {candidates.map((c, i) => <Reveal key={c.id} delay={i % 2 * 0.08} className="h-full" data-id="element-117" data-mp="3bhulethm5omb" data-mpi={i}>
                <CandidateCardWide candidate={c} onOpen={open} data-id="element-118" data-mp="2wsggbxl2ltcq" />
              </Reveal>)}
          </div> : <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-10 px-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-119" data-mp="31qqcobij6zzx">
            {candidates.map((c, i) => <Reveal key={c.id} delay={i % 4 * 0.08} className="h-full" data-id="element-120" data-mp="3u9drxaaujkt3" data-mpi={i}>
                <CandidateCard candidate={c} onOpen={open} data-id="element-121" data-mp="1itwrmtx023kd" />
              </Reveal>)}
          </div>}
      </div>

      <CandidateProfileModal candidate={activeIndex === null ? null : candidates[activeIndex]} total={candidates.length} onClose={() => setActiveIndex(null)} onNavigate={navigate} data-id="element-122" data-mp="1dvlg8er23l01" />

      <Lightbox open={posterOpen} onClose={() => setPosterOpen(false)} ariaLabel={`Lista No. 1 — Junta Directiva Cámara de Comercio de Cali, período ${election.period}`} maxWidth="max-w-2xl" data-id="element-123" data-mp="1nlwo2cdv2ec7">
        <img src={election.posterImage} alt="Pieza oficial de la Lista No. 1 con los ocho candidatos del Grupo Consultor Colombiano" className="w-full" data-id="element-124" data-mp="uyai4xh5uxm6" />
      </Lightbox>
    </section>;
}